import { render, staticRenderFns } from "./SignLoading.vue?vue&type=template&id=0a74956e&scoped=true&"
import script from "./SignLoading.vue?vue&type=script&lang=js&"
export * from "./SignLoading.vue?vue&type=script&lang=js&"
import style0 from "./SignLoading.vue?vue&type=style&index=0&id=0a74956e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a74956e",
  null
  
)

export default component.exports